var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[(_vm.$i18n.locale === 'en')?_vm._t("default",function(){return [_c('CertificateViewEn',{attrs:{"id":_vm.id,"circular_memo_no":_vm.circular_memo_no}})]}):_vm._t("default",function(){return [_c('CertificateViewBn',{attrs:{"id":_vm.id,"circular_memo_no":_vm.circular_memo_no}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }